import BreakpointsContext from "../context/breakpointsContext"
import { useContext, useMemo } from "react"
export default function useMini(breakpoint: string) {
    const context = useContext(BreakpointsContext)
    return useMemo(() => {
        if (!context) {
            return false
        }
        const { breakpoints, currentBreakpoint } = context
        return breakpoints[currentBreakpoint] < breakpoints[breakpoint]
    }, [context, breakpoint])
}
